import { Box, Button, TextField, Typography } from '@mui/material';
import React, { ChangeEvent, FormEvent } from 'react';

import { CommentComp } from 'app/components/comment-comp';
import { If } from 'app/components/if';
import { Comment } from 'app/model/comment';

interface CommentProps {
    comments: Comment[];

    addComment: (comment: string) => void;
}

interface CommentState {
    comment: string;
    showAll: boolean;
}

const MAX_COMMENTS = 5;

export class Comments extends React.Component<CommentProps, CommentState> {
    public constructor(props: CommentProps | Readonly<CommentProps>) {
        super(props);

        this.state = {
            comment: '',
            showAll: false,
        };

        // binding allows us to use this directly in template without doing '() => this.handleSubmit()'
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    public handleSubmit(evt: FormEvent): void {
        evt.preventDefault();
        if ('' === this.state.comment) {
            // TODO update to error display in form
            alert('blank comment not allowed');

            return;
        }

        this.props.addComment(this.state.comment);
    }

    public handleChange(evt: ChangeEvent<{ name?: string; value: string }>): void {
        this.setState({
            comment: evt.target.value,
        });
    }

    public render(): React.ReactNode {
        return (
            <form onSubmit={this.handleSubmit}>
                {0 === this.props.comments.length ? <Typography>No Comments</Typography> : ''}
                <If condition={this.hasHiddenComments()}>
                    <Box display='flex' flexDirection='column' p={1}>
                        <Button
                            variant='contained'
                            color='inherit'
                            size='small'
                            onClick={() => this.setState({ showAll: true })}
                        >
                            View {this.props.comments.length - MAX_COMMENTS} older comments
                        </Button>
                    </Box>
                </If>
                {this.getCommentSlice().map((comment) => (
                    <CommentComp key={comment.id} className='mb-2' comment={comment} />
                ))}
                <Typography variant='h6'>Add a comment</Typography>
                <TextField
                    fullWidth
                    name='comment'
                    label='Comment'
                    multiline
                    rows={4}
                    value={this.state.comment}
                    onChange={this.handleChange}
                />
                <Button type='submit' variant='outlined' color='primary' className='mt-2'>
                    Save Comment
                </Button>
            </form>
        );
    }

    private hasHiddenComments(): boolean {
        if (this.state.showAll) {
            return false;
        }

        return this.props.comments.length > MAX_COMMENTS;
    }

    private getCommentSlice(): Comment[] {
        if (this.state.showAll) {
            return this.props.comments;
        }

        return this.props.comments.slice(Math.max(this.props.comments.length - MAX_COMMENTS, 0));
    }
}
